import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";

const NAV_LINKS = [
  { label: "Platform", href: "#platform" },
  { label: "Consent", href: "/consent-management", isRoute: true },
  { label: "How it works", href: "#how" },
  { label: "Discovery", href: "#discovery" },
  { label: "AI & Savings", href: "#ai" },
  { label: "Policy Store", href: "#policies" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-[100] bg-ink/[.92] backdrop-blur-[14px] border-b border-white/[.06] py-[0.85rem]">
      <div className="container mx-auto max-w-[1140px] px-4 flex items-center justify-between flex-wrap">
        <a
          href="#"
          className="font-figtree font-bold text-[1.35rem] text-white tracking-[-0.01em] inline-flex items-center gap-[0.6rem]"
        >
          <img
            src="/assets/onedpdp-logo.png"
            alt=""
            width="36"
            height="36"
            className="h-9 w-9 object-cover rounded block bg-white"
          />
          One<span className="text-gold font-bold">DPDP</span>
        </a>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          className="lg:hidden border border-white/25 rounded p-2"
        >
          <span className="block w-6 h-0.5 bg-white mb-1" />
          <span className="block w-6 h-0.5 bg-white mb-1" />
          <span className="block w-6 h-0.5 bg-white" />
        </button>

        <div
          className={`${
            open ? "flex" : "hidden"
          } w-full lg:flex lg:w-auto flex-col lg:flex-row lg:items-center gap-1 mt-3 lg:mt-0`}
        >
          <ul className="flex flex-col lg:flex-row lg:items-center gap-1 list-none m-0 p-0">
            {NAV_LINKS.map((link) =>
              link.isRoute ? (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="block text-white/[.72] hover:text-white font-medium text-[0.92rem] px-[0.85rem] py-[0.4rem] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ) : (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="block text-white/[.72] hover:text-white font-medium text-[0.92rem] px-[0.85rem] py-[0.4rem] transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ),
            )}
            <li className="lg:ml-2 mt-2 lg:mt-0">
              <Link
                to="/login"
                className="inline-flex items-center gap-[0.4rem] bg-white/[.05] text-gold-bright border border-gold/[.45] hover:bg-gold hover:text-ink hover:border-gold font-semibold rounded-full px-[1.1rem] py-[0.5rem] text-[0.85rem] transition-all hover:-translate-y-px hover:shadow-[0_8px_20px_rgba(201,164,92,0.25)]"
              >
                <LogIn size={14} strokeWidth={2.25} />
                Login
              </Link>
            </li>
            <li className="lg:ml-2 mt-2 lg:mt-0">
              <a
                href="#contact"
                className="inline-block bg-teal hover:bg-teal-bright text-white font-semibold rounded px-[1.1rem] py-[0.5rem] text-[0.85rem] transition-all hover:-translate-y-px"
              >
                Request a demo
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
